import { NgTemplateOutlet } from "@angular/common";
import { ChangeDetectionStrategy, Component, ContentChild, EventEmitter, Input, model, Output, TemplateRef } from "@angular/core";
import { Router } from "@angular/router";
import { DialogModule } from "primeng/dialog";

type TDialogPosition = "center" | "top" | "bottom" | "left" | "right" | "topleft" | "topright" | "bottomleft" | "bottomright";

@Component({
  selector: "sxw-dialog",
  templateUrl: "./dialog.component.html",
  styleUrls: ["./dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, DialogModule],
})
export class DialogComponent {
  visible = model<boolean>(true);
  /**
   * "center", "top", "bottom", "left", "right", "top-left", "top-right", "bottom-left" or "bottom-right".
   */
  @Input() position: TDialogPosition = "center";
  @Input() replaceUrl = false;
  @Input() dialogClass = "";
  @Input() maskStyleClass = "";
  @Input() contentStyleClass = "";
  @Input() closable = true;
  @Input() breakpoints = null;
  @Input() defaultParentRoute = "";
  @Output() onShowDialog = new EventEmitter<any>();
  @Output() onHideDialog = new EventEmitter<any>();
  @ContentChild("header", { static: true }) header!: TemplateRef<any>;
  @ContentChild("content", { static: true }) content!: TemplateRef<any>;
  @ContentChild("footer", { static: true }) footer!: TemplateRef<any>;

  constructor(private route: Router) {}

  onShow(event: any) {
    this.onShowDialog.emit(event);
  }

  async onHide(event: any) {
    this.onHideDialog.emit(event);
    if (this.route.url.indexOf("/(") !== -1) {
      return await this.route.navigate([this.route.url.split("/(").shift()], { replaceUrl: this.replaceUrl });
    }
    const route = this.route.url.split("/");
    route.pop();
    return await this.route.navigate(route);
  }
}
